<button
    size="m"
    tuiButton
    type="button"
    (click)="onClick(content, header, 'fullscreen')"
>
    Show fullscreen
</button>

<ng-template
    #content
    let-observer
>
<main tuiNavigationMain>
    <div [style.grid-column]="'3 / span 8'">
        <div>
            <div>
                <button tuiButton size="s" appearance="primary">Monthly Plan </button>
            </div>
            <br>
            <div>
                <button tuiButton size="s" appearance="primary">Yearly Plan</button>
            </div>
            <br>
            <div>
                <button tuiButton size="s" appearance="primary">Custom Plan</button>
            </div>
        </div>
    </div>
</main>





   
</ng-template>

<ng-template #header>
    <div class="header">
       <h1 class="header-title"> Parking Plan Details</h1>
    </div>
</ng-template>
